// extracted by mini-css-extract-plugin
export default {"container":"sidebarTrigger_container__Y6CYz","opened":"sidebarTrigger_opened__L-SmD"};